import { useState } from 'react'

import { AttachmentValue } from '#/components/FormatCell/Types/attachments/types'
import { getS3URL } from '#/utils/download'

export function useAttachmentDownload(value: AttachmentValue | null | undefined) {
  const [fileController, setFileController] = useState<string | undefined>(undefined)

  async function handleClick() {
    if (!value?.url) {
      return
    }

    const fileURL = await getS3URL({ controller: value.url })
    setFileController(fileURL)
  }

  function closeExport() {
    setFileController(undefined)
  }

  return { closeExport, fileController, handleClick }
}
